export function has_app_history(state = window.history.state) {
  return Number.isInteger(state?.__navgo?.idx) && state.__navgo.idx > 0
}
